export default {
      id: "reports-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#reports",
      toString: function () {
        return this.url;
      }
    }